import whiteIntercept from './white-intercept';
import loginIntercept from './login-intercept';
import menuIntercept from './menu-intercept';
import * as enterpriseApp from '@V/enterprise-real/app';
import dataIntercept from './data-intercept';
import contractIntercept from './contract-intercept';
import storeIntercept from './store-intercept';

export default {
  whiteIntercept,
  loginIntercept,
  menuIntercept,
  entpIntercept: enterpriseApp.intercept,
  dataIntercept,
  storeIntercept,
  contractIntercept
};
